import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
import SingleCaseView from './single';
//import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router basename={process.env.REACT_APP_BASE_URL}>
      <Routes>
        <Route path='/' element={<App />} />
        <Route path='/single/' element={<SingleCaseView />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
